var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('cabecera'),_c('v-main',{staticStyle:{"background-color":"#6D9886"}},[_c('cabecerabaja',{staticClass:"hidden-md-only hidden-lg-only hidden-xl-only"}),_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"12","md":"12","sm":"12"}})],1)],1)],1),_c('piepagina')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }